document.addEventListener('DOMContentLoaded', function() {
  const description = document.querySelector('.collection__description .rte');
  if (!description) return;

  const paragraphs = description.querySelectorAll('p');
  if (paragraphs.length <= 2) return;

  // Hide paragraphs after the 2nd
  for (let i = 2; i < paragraphs.length; i++) {
    paragraphs[i].style.display = 'none';
  }

  // Create button
  const btn = document.createElement('button');
btn.textContent = 'Read more';
  btn.className = 'collection-description__toggle';
  description.appendChild(btn);

  btn.addEventListener('click', function() {
    const hidden = paragraphs[2].style.display === 'none';
    for (let i = 2; i < paragraphs.length; i++) {
      paragraphs[i].style.display = hidden ? 'block' : 'none';
    }
btn.textContent = hidden ? 'Read less' : 'Read more';
  });
});
